/**
 * Разворачивает payload GraphQL-мутации, у которой схема допускает `null`,
 * но контракт операции гарантирует значение при успешном ответе.
 */
export function requirePayload<Payload>(payload: Payload | null | undefined, message: string): Payload {
  if (payload === null || payload === undefined) {
    throw new Error(message);
  }

  return payload;
}
